module.exports = __webpack_public_path__ + "img/reject-icon-active.dc0b599a.svg";